import React, {useEffect, useState } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import { Link } from 'react-router-dom'
import Common_form from '../../components/Common_form'
import { AiFillHome, AiOutlineAppstore } from 'react-icons/ai'
import LoginModal from '../../components/LoginModel'; // Import the modal
import { useAuth } from '../../context/auth'; // Import the useAuth hook

const LegalDrafting = () => {
  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal visibility
  const [auth] = useAuth(); // Access auth state from context
  const isLoggedIn = Boolean(auth.token); // Determine if user is logged in based on token

  useEffect(() => {
    // Show the modal if the user is not logged in
    if (!isLoggedIn) {
      setIsModalOpen(true); // Show the modal if not logged in
    }
  }, [isLoggedIn]); // Run effect whenever isLoggedIn changes

  const closeModal = () => {
    setIsModalOpen(false); // Function to close modal
  };

  return (
    <div className='bg-slate-100'>
      <Header />
      {/* Page Title */}
      <div className="page-title py-6 bg-slate-300" data-aos="fade">
        <div className="container mx-auto px-4 lg:px-20 flex flex-col lg:flex-row justify-between items-start lg:items-center">
          {/* Title */}
          <h1 className=" text-black text-xl md:text-2xl font-semibold">Legal Notice</h1>

          {/* Refund message */}
          <style jsx>{`
      @keyframes intenseBlink {
        0%, 100% { opacity: 1; color: #f20000; }
        20% { opacity: 1; color: #000000; }
      }
    `}</style>
          <h1
            className="
        text-lg md:text-xl font-bold underline underline-offset-8 
        mb-2 lg:mb-0 lg:ml-4 
        animate-[intenseBlink_1s_ease-in-out_infinite]
      "
          >
            100% Fees Refundable, if Service is not Completed!
          </h1>

          {/* Breadcrumbs */}
          <nav className="breadcrumbs mt-2 lg:mt-0">
            <ol className="flex space-x-2 lg:space-x-4 text-sm items-center">
              <li className="flex items-center">
                <AiFillHome className="mr-1 text-base hover:underline" />
                <Link to={'/'} className="text-black hover:underline text-base">Home</Link>
              </li>
              <li className="text-black">/</li>
              <li className="flex items-center">
                <AiOutlineAppstore className="mr-1 text-base" />
                <Link to={'/all_service'} className="text-black hover:underline text-base">All Services</Link>
              </li>
            </ol>
          </nav>
        </div>
      </div>
      <div className="container mx-auto px-4 lg:px-16 py-8">
      <div className="text-center mb-8">
  <h2 className="text-2xl lg:text-3xl font-bold border-b-4 border-red-600 inline-block pb-2">
    Legal Drafting Services
  </h2>
  <h3 className="pt-4 text-base font-semibold">
    Professional Legal Documentation | Accurate & Compliant Drafting Services
  </h3>
  <p className="pt-4">
    **Legal Drafting** involves the structured and precise preparation of legal documents, including agreements, contracts, wills, and statutory documents. It ensures clarity, enforceability, and legal compliance, reducing the risk of disputes.  
  </p>
  <p className="pt-4">
    Our expert legal drafting services provide meticulously crafted documents to protect your rights and interests while ensuring adherence to legal norms. Whether it's corporate agreements, business contracts, property deeds, or personal legal documents, we guarantee accuracy and legal validity.
  </p>
</div>

        <hr class="h-px my-9 bg-gray-700 border-none dark:bg-gray-700" />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left side - Form */}

          <Common_form application_type="LegalDrafting" />

          {/* Right side - Content */}
          <div className="bg-slate-200 p-3">
  <h1 className="text-2xl font-bold mb-4">
    What is Legal Drafting? What purpose does it serve?
  </h1>
  <p className="mb-4">
    **Legal Drafting** is the process of preparing structured, clear, and legally enforceable documents, such as contracts, agreements, wills, and other legal instruments. It ensures compliance with legal standards, minimizes disputes, and safeguards the rights of all parties involved.  
  </p>
  <h2 className="text-xl font-semibold mb-2">When is Legal Drafting Required?</h2>
  <p>
    Legal drafting is essential for creating legally binding agreements and documents. It is commonly used in various situations, including:
    <br />
    • **Business Agreements** – Contracts, partnership deeds, employment agreements, and service-level agreements.
    <br />
    • **Property Documentation** – Sale deeds, lease agreements, wills, and mortgage contracts.
    <br />
    • **Corporate & Compliance Documents** – Memorandum of association, articles of association, and regulatory filings.
    <br />
    • **Personal Legal Documents** – Affidavits, power of attorney, and legal declarations.
  </p>
</div>

        </div>
      </div>
  {/* Render Login Modal only if not logged in */}
  {!isLoggedIn && isModalOpen && <LoginModal closeModal={closeModal} />}
      <Footer />
    </div>
  )
}

export default LegalDrafting;
